// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WexPn","content":"styles_content__2VM9s"};